import { useAuth } from "@agentech/auth-client";
import { useEffect, useState } from "react";
import { AuthStatusScreen } from "../components/AuthStatusScreen";
import { config } from "../config";

export function CallbackPage() {
  const { isAuthenticated, isLoading, error } = useAuth();
  const [status, setStatus] = useState<"processing" | "success" | "error">("processing");

  useEffect(() => {
    if (isLoading) {
      setStatus("processing");
      return;
    }

    if (error) {
      setStatus("error");
      return;
    }

    if (isAuthenticated) {
      setStatus("success");

      // Get the return URL
      const returnTo = sessionStorage.getItem("auth_return_to");

      if (returnTo) {
        sessionStorage.removeItem("auth_return_to");
        // Small delay to show success state
        setTimeout(() => {
          window.location.href = returnTo;
        }, 500);
      } else {
        // Redirect directly to platform to avoid a flash of the login page
        setTimeout(() => {
          window.location.href = `https://platform.${config.baseDomain}`;
        }, 500);
      }
    }
  }, [isAuthenticated, isLoading, error]);

  return (
    <AuthStatusScreen>
      {status === "processing" && (
        <>
          <div className="loading-spinner" />
          <h2>Signing you in</h2>
          <p>Please wait while we complete authentication.</p>
        </>
      )}

      {status === "success" && (
        <>
          <div className="success-icon">&#10003;</div>
          <h2>Success</h2>
          <p>Redirecting you to your workspace...</p>
        </>
      )}

      {status === "error" && (
        <>
          <div className="error-icon">&#10007;</div>
          <h2>Authentication failed</h2>
          <p>{error?.message ?? "An unexpected error occurred."}</p>
          <a href="/" className="btn btn-primary">
            Back to sign in
          </a>
        </>
      )}
    </AuthStatusScreen>
  );
}
